import { momentFromDateTimeWithZone } from '@banking/ui/utils/datetime-converter';
import { getImage, fromBalanceReportItem } from './from-balance-report-item';
export function fromBalanceReportBundle(balanceReportItem) {
  if (!balanceReportItem.displayData || !balanceReportItem.displayData.amount || !balanceReportItem.displayData.balance || !balanceReportItem.displayData.displayDate || !balanceReportItem.displayData.image) {
    throw new Error('transaction missing data');
  }
  const bundle = {
    amount: balanceReportItem.displayData.amount,
    activities: balanceReportItem.balanceReportItems.map(fromBalanceReportItem),
    availableAt: momentFromDateTimeWithZone(balanceReportItem.displayData.displayDate).toDate(),
    balance: balanceReportItem.displayData.balance,
    createdAt: momentFromDateTimeWithZone(balanceReportItem.displayData.displayDate).toDate(),
    isInstant: false,
    description: balanceReportItem.displayData.description,
    fromAccountName: null,
    id: balanceReportItem.id,
    image: getImage(balanceReportItem.displayData.image),
    isAvailable: false,
    isBundle: true,
    isSettled: false,
    isPending: false,
    isVoided: false,
    settledAt: new Date(),
    subtitle: balanceReportItem.displayData.description,
    svgModifierClass: '',
    svgName: '24px-square',
    state: null,
    title: balanceReportItem.displayData.title,
    toAccountName: null,
    traceId: '',
    transactionToken: null,
    willEarnInterest: false,
    isUnavailableAndEarningInterest: false
  };
  return bundle;
}